module.exports = __webpack_public_path__ + "static/media/logo-imagine-header.dc55da23.png";